import React, { useMemo, useState } from 'react';

import { connect, useSelector } from 'react-redux'

import pageWithSideMenu from '../../containers/pageWithSideMenu'
import pageContent from '../../containers/pageContent'

import CardHeader from '../../containers/CardHeader'

import { Breadcrumb, Card } from 'react-bootstrap'
import InvalidPermissions from '../../containers/InvalidPermissions'
import landerAPICall from '../../app/apiCalls/landerAPICall';
import { landers_list } from '../../app/apiEndpoints';

import DataTable from '../../containers/DataTable';
import { tableTypes } from '../../app/settings';

const LanderSection = (props) => {
    const [data, setData] = useState([])

    const tableID = "path"
    const tableFields = ["Landing Page Type", "# of Landers"]

    const userID = useSelector((state) => state.user.id)
    const companyID = useSelector((state) => state.user.company.id)
    const isSysadmin = useSelector((state) => state.user.isSysadmin)

    useMemo(() => {
        const getData = async () => {
            const data = await landerAPICall(landers_list, {'requester': userID, 'company': companyID, 'cascadeType': "" })
            setData(data.landers)
        }
        getData()
    }, [userID, companyID])

    const tableData = () => {
        if(data.length === 0) {
            return [];
        } 
        let rows = [];
        data.forEach((row) => {
            rows.push({'id': row.link, 'values': [
                `<a href="/landers/${row.link}/">${row.name}</a>`,
                row.count ?? "0"
            ]});
        });
        return rows
    }

    if(!isSysadmin) return <InvalidPermissions />

    return (
        <>
        <Breadcrumb>
          <Breadcrumb.Item active>Paths</Breadcrumb.Item>
        </Breadcrumb>
        <Card>
            <CardHeader title="Landing Pages" description="Listing of Landing Page Types" />
            <DataTable hover={true} tableID={tableID} fieldNames={tableFields} dataRows={tableData()} totals={false} tableSettings={tableTypes.None} />
        </Card>
        </>
    )
}

export default connect(state => ({...state}))(pageWithSideMenu(pageContent(LanderSection), "Landing Pages"));
